import {
  ApiOrderHistory,
  ApiOrderHistoryRequest,
  ApiOrderHistoryResponse,
  UpdateApiOrderDeliveryStatusRequest,
} from "@/features/api-order/types";
import axiosClient from "@/utils/axios-client";
import { OrderSheetStatus } from "@/features/order-sheets/order-sheet.type";
import { CompanyTypeRequestFormat } from "@/shared/types";
import { CompanyType } from "@/features/types";
import { StoredObject } from "@/features/types";

const url = {
  getApiOrderHistory: (
    companyType?: CompanyTypeRequestFormat,
    companyId?: number
  ) => `/${companyType}/${companyId}/api-orders`,

  uploadUnoFile: () => `/uno-files`,

  updateApiOrderAttachments: (agencyId: number, orderId: number) =>
    `/agencies/${agencyId}/api-orders/${orderId}/update-attachments`,
  updateOrderStatus: (
    companyType?: CompanyTypeRequestFormat,
    companyId?: number,
    orderId?: number
  ) => `/${companyType}/${companyId}/api-orders/${orderId}/update-status`,
  updateDeliveryStatus: (agencyId?: number, orderId?: number) =>
    `/agencies/${agencyId}/api-orders/${orderId}/update-delivery-status`,

  deleteApiOrder: (buyerId: number, orderId: number) =>
    `/buyers/${buyerId}/api-orders/${orderId}`,
};

export const apiOrderApi = {
  getApiOrderHistory: async (
    params: ApiOrderHistoryRequest,
    companyType?: CompanyTypeRequestFormat,
    companyId?: number
  ) => {
    const { data } = await axiosClient.get<ApiOrderHistoryResponse>(
      url.getApiOrderHistory(companyType, companyId),
      {
        params,
      }
    );
    return data;
  },

  updateOrderStatus: async (
    companyType?: CompanyTypeRequestFormat,
    companyId?: number,
    orderId?: number,
    data?: { status: OrderSheetStatus }
  ) => {
    return await axiosClient.put(
      url.updateOrderStatus(companyType, companyId, orderId),
      data
    );
  },
  updateDeliveryStatus: async (
    agencyId?: number,
    orderId?: number,
    data?: UpdateApiOrderDeliveryStatusRequest
  ) => {
    return await axiosClient.put(
      url.updateDeliveryStatus(agencyId, orderId),
      data
    );
  },
  uploadUnoFile: async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    return await axiosClient.post(url.uploadUnoFile(), formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      // 파일 업로드는 인스턴스 기본값 30초로 끊으면 안 된다.
      timeout: 60 * 60 * 1000,
    });
  },
  updateApiOrderAttachments: async (
    agencyId: number,
    orderId: number,
    data: {
      attachments: {
        uno_file_id: number;
        boutique_id: number;
      }[];
    }
  ) => {
    return await axiosClient.put(
      url.updateApiOrderAttachments(agencyId, orderId),
      data
    );
  },

  deleteApiOrder: async (buyerId: number, orderId: number) => {
    return await axiosClient.delete(url.deleteApiOrder(buyerId, orderId));
  },
};
